<template>
  <v-container class="content-font-size pt-0" :style="rowWidth" fluid>
    <div class="background-color-white rounded-lg mb-3 mb-sm-6 mr-sm-0">
      <v-col cols="12">
        <v-row
          :justify="'space-between'"
          class="font-24 header-text mt-3 main-header mb-2 mx-2"
        >
          <v-col cols="4"> Store Points</v-col>
          <v-col cols="8" style="text-align: right">
            <span style="font-weight: 400; color: rgba(255, 255, 255, 0.6)"
              >My Balance:</span
            >
            {{ total_points_remaining || 0 }} points
          </v-col>
        </v-row>
        <v-row class="pb-1">
          <v-col cols="12" class="header-text ml-5"> Available Rewards</v-col>
        </v-row>
        <v-row class="py-5 pt-0 mt-0">
          <v-col cols="12" class="click-to-see-rewards pt-0 ml-5">
            <span v-if="availableRewards().length"
              >Click to see rewards you can redeem right now</span
            >
            <span v-else>No rewards available</span>
          </v-col>
        </v-row>
        <RewardsTabs
          type="points"
          :points="availableRewards()"
          :redeemable="true"
        />
        <v-row class="pb-1">
          <v-col cols="12" class="header-text ml-5"> Next Level Rewards</v-col>
        </v-row>
        <v-row class="py-5 pt-0 mt-0">
          <v-col cols="12" class="click-to-see-rewards pt-0 ml-5">
            <span v-if="nextLevelRewards().length"
              >Click to see rewards you can redeem after earning more
              points</span
            >
            <span v-else>No rewards available</span>
          </v-col>
        </v-row>
        <RewardsTabs type="points" :points="nextLevelRewards()" />
      </v-col>
    </div>
  </v-container>
</template>

<script>
import { mapGetters, mapState } from "vuex";
import RewardsTabs from "./Tabs.vue";

export default {
  name: "RewardsPoints",
  components: {
    RewardsTabs,
  },
  computed: {
    ...mapGetters("store", {
      total_points_remaining: "total_points_remaining",
      points_offers: "points_offers",
    }),
    ...mapState({
      points: (state) => state.store.info.points,
    }),
    rowWidth() {
      return this.$vuetify.breakpoint.xsOnly ? "width: 100vw" : "";
    },
  },
  methods: {
    availableRewards() {
      let offers = this.points_offers.filter(
        (x) =>
          (!x.xtra.paywithpoints && x.points <= this.points?.total_points) || 0,
      );
      offers.forEach((o) => {
        o.xtra.products.forEach((p) => {
          p.redemption_points_offer_id = o.offering_id;
          p.redemption_points_offer = o.points;
        });
      });
      return offers;
    },
    nextLevelRewards() {
      let offers = this.points_offers.filter((x) => {
        if (x.xtra.paywithpoints) return false;
        if (this.points?.total_points) {
          return x.points > this.points.total_points;
        } else return true;
      });
      offers.forEach((o) => {
        o.xtra.products.forEach((p) => {
          p.redemption_points_offer = o.points;
        });
      });
      return offers;
    },
  },
};
</script>
